import React from 'react'

import { getUIErrorMessage } from './error.helper'
// ako postoji greška prikazati je...

import errorIcon from '../../images/error-icon.svg'

import './error.styles.css'

const Error = ({ loading, data, error, dispatch }) => {
 
  if (error && !loading) {
    const errorURL = data?.errorURL
    const uiError = error.data ? getUIErrorMessage(error.data) : getUIErrorMessage(error)
    
    return (
      <React.Fragment>
        <div className="backdrop"/>
        <div className="error-modal">
          <img src={errorIcon} alt=""/>
          <h1 className="error-modal-title">{uiError.title || ''}</h1>
          <div className="error-modal-content">
            <p className="error-modal-message">{ uiError.message}</p>
            { uiError.id && <p  className="error-modal-message">{uiError.id}</p>}
          </div>
          
          <div className="..error-modal__actions">
            { uiError.repeatButton && 
                <button className="error-button" onClick={()=> { dispatch({type:'ERROR_CLEAR'}) }}>Ponovi</button>
            }
            { errorURL 
                ? <button className="error-button error-button-cancel" onClick={()=>{ window.location.replace(errorURL + data.token)}}>Odustani</button> 
                : <button className="error-button error-button-cancel" onClick={()=>{
                    window.location.replace(process.env.REACT_APP_REDIRECT_PAGE)
                 }}>Zatvori</button>
            }
            
          </div>
        </div>
      </React.Fragment>
    )
  }
  return null
}


export default Error